<template>
    <div class="settings-dispatch-receivers">
        <div class="settings-dispatch-receivers__toolbar">
            <div class="settings-dispatch-receivers__toolbar-left">
                <el-button type="primary" size="small" @click="openCreateDialog">+新增外派员</el-button>
            </div>
            <div class="settings-dispatch-receivers__toolbar-right">
                <el-input
                    v-model.trim="searchInput"
                    size="small"
                    clearable
                    placeholder="搜索姓名/登录名/手机号"
                    class="settings-dispatch-receivers__search app-search-input"
                    @keyup.enter.native="applySearch"
                >
                    <el-button slot="append" icon="el-icon-search" @click="applySearch" />
                </el-input>
                <el-button size="small" @click="resetSearch">重置</el-button>
            </div>
        </div>

        <div class="settings-dispatch-receivers__table-wrap">
            <el-table
                v-loading="loading"
                :data="displayedRows"
                border
                stripe
                size="small"
                class="settings-dispatch-receivers__table"
                fit
            >
                <el-table-column label="创建时间" min-width="154" align="center" header-align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ formatCreatedAt(row) }}</template>
                </el-table-column>
                <el-table-column label="姓名" min-width="72" align="center" header-align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ row.name || '—' }}</template>
                </el-table-column>
                <el-table-column label="登录名" min-width="110" align="center" header-align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ row.username || '—' }}</template>
                </el-table-column>
                <el-table-column label="手机" min-width="118" align="center" header-align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ row.phone || '—' }}</template>
                </el-table-column>
                <el-table-column label="对接专员" min-width="120" align="center" header-align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ liaisonDisplay(row) }}</template>
                </el-table-column>
                <el-table-column label="状态" min-width="76" align="center" header-align="center">
                    <template slot-scope="{ row }">
                        <el-tag :type="Number(row.status) === 1 ? 'success' : 'info'" size="mini">
                            {{ Number(row.status) === 1 ? '启用' : '停用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100" align="center" header-align="center">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="small" @click="openEditDialog(row)">编辑</el-button>
                        <el-button type="text" size="small" class="settings-dispatch-receivers__danger" @click="removeUser(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="listTotal > 0" class="settings-dispatch-receivers__pager">
            <el-pagination
                background
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100]"
                :current-page="page"
                :page-size="perPage"
                :total="listTotal"
                @current-change="handlePageChange"
                @size-change="handlePageSizeChange"
            />
        </div>

        <el-dialog
            :title="editingUserId ? '编辑外派员' : '新增外派员'"
            :visible.sync="createDialogVisible"
            width="560px"
            :close-on-click-modal="false"
            @closed="resetCreateForm"
        >
            <el-form ref="createFormRef" :model="createForm" :rules="createRules" label-width="100px" size="small">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model.trim="createForm.name" maxlength="100" autocomplete="off" />
                </el-form-item>
                <el-form-item v-if="!editingUserId" label="登录名" prop="username">
                    <el-input v-model.trim="createForm.username" :disabled="!!editingUserId" maxlength="50" autocomplete="off" />
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model.trim="createForm.phone" maxlength="11" autocomplete="off" />
                </el-form-item>
                <el-form-item label="登录密码" prop="password">
                    <el-input v-model.trim="createForm.password" show-password autocomplete="new-password" />
                </el-form-item>
                <el-form-item label="外派范围" prop="dispatch_scope">
                    <el-radio-group v-model="createForm.dispatch_scope">
                        <el-radio :label="1">税务</el-radio>
                        <el-radio :label="2">工商</el-radio>
                        <el-radio :label="3">税务+工商</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="对接专员" prop="liaison_user_id">
                    <el-select
                        v-model="createForm.liaison_user_id"
                        filterable
                        clearable
                        placeholder="选择子账号（可选）"
                        class="settings-dispatch-receivers__liaison-select"
                    >
                        <el-option
                            v-for="u in liaisonUserOptions"
                            :key="u.id"
                            :label="liaisonOptionLabel(u)"
                            :value="u.id"
                        />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="createDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="creating" @click="submitCreateForm">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'SettingsDispatchReceivers',
    data: function () {
        return {
            loading: false,
            rows: [],
            allUsers: [],
            liaisonUserOptions: [],
            createDialogVisible: false,
            editingUserId: null,
            creating: false,
            permissionsMap: {},
            createForm: {
                name: '',
                username: '',
                phone: '',
                password: '',
                dispatch_scope: 3,
                liaison_user_id: null
            },
            createRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                username: [],
                phone: [
                    {
                        validator: function (rule, value, callback) {
                            var s = value != null ? String(value).trim() : '';
                            if (s === '') {
                                callback();
                                return;
                            }
                            if (!/^1[3-9]\d{9}$/.test(s)) {
                                callback(new Error('请输入11位有效手机号（1开头）'));
                                return;
                            }
                            callback();
                        },
                        trigger: 'blur'
                    }
                ],
                password: []
            },
            searchInput: '',
            searchApplied: '',
            page: 1,
            perPage: 10
        };
    },
    computed: {
        filteredRows: function () {
            var q = (this.searchApplied || '').toLowerCase();
            if (!q) {
                return this.rows;
            }
            return this.rows.filter(function (r) {
                var blob = [r.name, r.username, r.phone, String(r.id || '')].join(' ').toLowerCase();
                return blob.indexOf(q) >= 0;
            });
        },
        listTotal: function () {
            return this.filteredRows.length;
        },
        displayedRows: function () {
            var start = (this.page - 1) * this.perPage;
            return this.filteredRows.slice(start, start + this.perPage);
        }
    },
    created: function () {
        this.fetchPermissionsMap();
        this.fetchLiaisonUsers();
        this.fetchList();
    },
    methods: {
        liaisonDisplay: function (row) {
            if (!row || !row.liaison_user) {
                return '—';
            }
            var u = row.liaison_user;
            if (u.name) {
                return u.username ? String(u.name) + '（' + String(u.username) + '）' : String(u.name);
            }
            return u.username ? String(u.username) : '—';
        },
        liaisonOptionLabel: function (u) {
            if (!u) {
                return '';
            }
            if (u.name) {
                return u.username ? String(u.name) + '（' + String(u.username) + '）' : String(u.name);
            }
            return u.username ? String(u.username) : String(u.id);
        },
        fetchLiaisonUsers: function () {
            var _this = this;
            window.axios.get('/users').then(function (res) {
                var users = (res.data && res.data.data) || [];
                _this.allUsers = users;
                _this.liaisonUserOptions = users.filter(function (u) {
                    return Number(u.is_super_admin || 0) !== 1 && Number(u.status || 0) === 1;
                });
            }).catch(function () {
                _this.allUsers = [];
                _this.liaisonUserOptions = [];
            });
        },
        formatCreatedAt: function (row) {
            if (!row || !row.created_at) {
                return '—';
            }
            var s = String(row.created_at);
            if (s.length >= 19) {
                return s.slice(0, 19).replace('T', ' ');
            }
            return s.length >= 10 ? s.slice(0, 10) : s;
        },
        fetchList: function () {
            var _this = this;
            this.loading = true;
            window.axios.get('/dispatch/receivers', { params: { dispatch_scope: 3 } }).then(function (res) {
                _this.rows = (res.data && res.data.data) || [];
            }).catch(function () {
                _this.$message.error('加载外派人员失败');
                _this.rows = [];
            }).finally(function () {
                _this.loading = false;
            });
        },
        fetchPermissionsMap: function () {
            var _this = this;
            window.axios.get('/permissions').then(function (res) {
                var list = (res.data && res.data.data) || [];
                var map = {};
                for (var i = 0; i < list.length; i++) {
                    map[String(list[i].code || '')] = list[i].id;
                }
                _this.permissionsMap = map;
            }).catch(function () {
                _this.permissionsMap = {};
            });
        },
        openCreateDialog: function () {
            this.resetCreateForm();
            this.createDialogVisible = true;
        },
        openEditDialog: function (row) {
            if (!row || !row.id) {
                return;
            }
            var detail = null;
            for (var i = 0; i < this.allUsers.length; i++) {
                if (Number(this.allUsers[i].id) === Number(row.id)) {
                    detail = this.allUsers[i];
                    break;
                }
            }
            var perms = detail && detail.effective_permissions ? detail.effective_permissions : [];
            var hasTax = perms.indexOf('tax.edit') >= 0;
            var hasBiz = perms.indexOf('biz.edit') >= 0;
            var scope = 3;
            if (hasTax && !hasBiz) {
                scope = 1;
            } else if (!hasTax && hasBiz) {
                scope = 2;
            }
            this.editingUserId = Number(row.id);
            this.createForm = {
                name: row.name || '',
                username: row.username || '',
                phone: row.phone || '',
                password: '',
                dispatch_scope: scope,
                liaison_user_id: row.liaison_user_id != null && row.liaison_user_id !== '' ? Number(row.liaison_user_id) : null
            };
            if (this.$refs.createFormRef) {
                this.$refs.createFormRef.clearValidate();
            }
            this.createDialogVisible = true;
        },
        resetCreateForm: function () {
            this.editingUserId = null;
            this.createForm = {
                name: '',
                username: '',
                phone: '',
                password: '',
                dispatch_scope: 3,
                liaison_user_id: null
            };
            if (this.$refs.createFormRef) {
                this.$refs.createFormRef.clearValidate();
            }
        },
        submitCreateForm: function () {
            var _this = this;
            if (!this.$refs.createFormRef) {
                return;
            }
            this.$refs.createFormRef.validate(function (valid) {
                if (!valid) {
                    return;
                }
                var pwd = String(_this.createForm.password || '');
                if (!_this.editingUserId) {
                    if (pwd.length < 6) {
                        _this.$message.warning('登录密码至少6位');
                        return;
                    }
                } else if (pwd.length > 0 && pwd.length < 6) {
                    _this.$message.warning('重置密码至少6位');
                    return;
                }

                var permissionOverrides = [];
                function grant(code) {
                    var id = _this.permissionsMap[String(code)];
                    if (id) {
                        permissionOverrides.push({ permission_id: id, grant_type: 1 });
                    }
                }
                grant('dispatch.receive');
                var scope = Number(_this.createForm.dispatch_scope || 3);
                if (scope === 1 || scope === 3) {
                    grant('tax.edit');
                }
                if (scope === 2 || scope === 3) {
                    grant('biz.edit');
                }

                _this.creating = true;
                var payload = {
                    name: _this.createForm.name,
                    phone: _this.createForm.phone || null,
                    status: 1,
                    account_type: 2,
                    liaison_user_id: _this.createForm.liaison_user_id != null && _this.createForm.liaison_user_id !== ''
                        ? Number(_this.createForm.liaison_user_id)
                        : null,
                    permission_overrides: permissionOverrides
                };
                if (!_this.editingUserId) {
                    var inputUsername = _this.createForm.username != null ? String(_this.createForm.username).trim() : '';
                    payload.username = inputUsername !== '' ? inputUsername : ('dispatch_' + Date.now());
                    payload.password = pwd;
                } else if (pwd.length > 0) {
                    payload.password = pwd;
                }
                var request = _this.editingUserId
                    ? window.axios.put('/users/' + _this.editingUserId, payload)
                    : window.axios.post('/users', payload);

                request.then(function () {
                    _this.$message.success(_this.editingUserId ? '外派员更新成功' : '外派员创建成功');
                    _this.createDialogVisible = false;
                    _this.fetchLiaisonUsers();
                    _this.fetchList();
                }).catch(function (error) {
                    var data = error && error.response && error.response.data ? error.response.data : {};
                    var msg = data.message ? String(data.message) : (_this.editingUserId ? '外派员更新失败' : '外派员创建失败');
                    _this.$message.error(msg);
                }).finally(function () {
                    _this.creating = false;
                });
            });
        },
        applySearch: function () {
            this.searchApplied = (this.searchInput || '').trim();
            this.page = 1;
        },
        resetSearch: function () {
            this.searchInput = '';
            this.searchApplied = '';
            this.page = 1;
        },
        handlePageChange: function (p) {
            this.page = p;
        },
        handlePageSizeChange: function (size) {
            this.perPage = size;
            this.page = 1;
        },
        removeUser: function (row) {
            var _this = this;
            if (!row || !row.id) {
                return;
            }
            this.$confirm('确认删除外派员「' + (row.name || '未命名') + '」吗？删除后不可恢复。', '删除确认', {
                type: 'warning'
            }).then(function () {
                return window.axios.delete('/users/' + row.id);
            }).then(function () {
                _this.$message.success('外派员已删除');
                _this.fetchLiaisonUsers();
                _this.fetchList();
            }).catch(function (error) {
                if (error === 'cancel') {
                    return;
                }
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '删除失败';
                _this.$message.error(message);
            });
        }
    }
};
</script>

<style scoped>
.settings-dispatch-receivers__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
}

.settings-dispatch-receivers__toolbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.settings-dispatch-receivers__search {
    width: 320px;
}

.settings-dispatch-receivers__liaison-select {
    width: 100%;
}

.settings-dispatch-receivers__pager {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
}

.settings-dispatch-receivers__danger {
    color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SettingsDispatchReceivers.vue